@if (icon) {
  <wp-flag [name]="'flags/' + countryFlag(icon)" aria-label="{{ icon }} flag"> </wp-flag>
} @else {
  <wp-chips state="neutral" contrast="contrast" type="indicator">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </wp-chips>
}
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
